import produce from 'immer';
import types from './types';
import initialState from './initialState';

// eslint-disable-next-line consistent-return
export default produce((draft, { type, data }) => {
  switch (type) {
    case types.SET_STATE: {
      draft.playerStates = data;

      break;
    }

    case types.UPDATE_PLAYER_STATE: {
      const index = draft.playerStates.findIndex(
        (p) => p.playerName === data.playerName,
      );
      if (index >= 0) {
        draft.playerStates[index] = data;
      } else {
        draft.playerStates.push(data);
      }

      break;
    }

    default: {
      break;
    }
  }
}, initialState);
